import Vue from 'vue'
import {mutationTypes} from '#/notes/store/mutationTypes'
import {initState} from '#/notes/store/state'
import {reset} from '#/notes/store/helpers'
import {omit as _omit, keys as _keys, unionBy as _unionBy} from 'lodash'
import {defaultPagination} from '#/notes/components/definitions'

const mutations = {
  [mutationTypes.RESET]: reset(initState),
  [mutationTypes.SET_NOTES] (state, noteRecords) {
    state.noteRecords = noteRecords
  },
  [mutationTypes.APPEND_NOTES] (state, noteRecords) {
    state.noteRecords = _unionBy(state.noteRecords, noteRecords, 'id')
  },
  [mutationTypes.UPDATE_NOTE] (state, note) {
    const index = state.noteRecords.findIndex(item => item.id === note.id)
    if (index === -1) {
      state.noteRecords.unshift(note)
    } else {
      Vue.set(state.noteRecords, index, note)
    }
  },
  [mutationTypes.SET_SEARCH] (state, search) {
    state.currentSearch = search
  },
  [mutationTypes.SET_CONSUMER_FILTERS] (state, filters) {
    state.consumerFilters = filters
  },
  [mutationTypes.UPDATE_USER_FILTERS] (state, filters) {
    state.userFilters = {...state.userFilters, ...filters}
  },
  [mutationTypes.REMOVE_USER_FILTERS] (state, filters) {
    state.userFilters = _omit(state.userFilters, _keys(filters))
  },
  [mutationTypes.RESET_USER_FILTERS] (state) {
    state.userFilters = {}
  },
  [mutationTypes.UPDATE_PAGINATION] (state, pagination) {
    if (!pagination) return
    state.currentPagination = {...state.currentPagination, ...pagination}
  },
  [mutationTypes.TOGGLE_PAGINATED_FETCHING] (state, flag) {
    state.currentPagination = flag ? defaultPagination : null
  },
  [mutationTypes.TOGGLE_IS_FETCHING] (state, flag) {
    state.isFetching = flag
  },
  [mutationTypes.SET_CURRENT_NOTE] (state, note) {
    state.currentNoteRecord = note
  },
  [mutationTypes.RESET_CURRENT_NOTE] (state) {
    state.currentNoteRecord = null
  },
  [mutationTypes.SET_CURRENT_NOTE_HISTORY] (state, noteHistory) {
    state.currentNoteHistory = noteHistory
  },
  [mutationTypes.REMOVE_NOTE_BY_ID] (state, id) {
    state.noteRecords = state.noteRecords.filter(item => item.id !== id)
  },
  [mutationTypes.SET_READING_MODE] (state, readingMode) {
    state.readingMode = readingMode
  },
  [mutationTypes.SET_CURRENT_MODE] (state, mode) {
    state.currentMode = mode
  },
  [mutationTypes.SET_ENVIRONMENT] (state, environment) {
    state.environment = environment
  },
  [mutationTypes.SET_USER_FILTERS_METADATA] (state, metadata) {
    state.userFiltersMetadata = metadata
  },
  [mutationTypes.RESET_USER_FILTERS_METADATA] (state) {
    state.userFiltersMetadata = {}
  },
  [mutationTypes.SET_NOTE_TAGS] (state, noteTags) {
    state.noteTags = noteTags
  },
  [mutationTypes.SET_NOTE_TYPES] (state, noteTypes) {
    state.noteTypes = noteTypes
  },
  [mutationTypes.SET_DOMAINS] (state, domains) {
    state.domains = domains
  },
  [mutationTypes.SET_NOTE_IS_DIRTY] (state, noteIsDirty) {
    state.noteIsDirty = noteIsDirty
  }
}
export default mutations
